import React from "react";
import { Spinner } from "react-bootstrap";

const CircularLoader = ({ message = "Loading...", size = "md" }) => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "32px 16px",
                gap: "12px",
            }}
        >
            <Spinner
                animation="border"
                role="status"
                style={{
                    width: size === "sm" ? "30px" : size === "lg" ? "50px" : "40px",
                    height: size === "sm" ? "30px" : size === "lg" ? "50px" : "40px",
                    color: "#3b82f6",
                }}
            >
                <span className="visually-hidden">Loading...</span>
            </Spinner>
            {message && <p style={{ margin: 0, color: "#64748b", fontSize: "14px" }}>{message}</p>}
        </div>
    );
};

export default CircularLoader;
